const $ = jQuery

export default class ImgToSvg {
  constructor () {
    $('img.svg').each(function () {
      const $img = jQuery(this)
      const imgURL = $img.attr('src')
      const attributes = $img.prop('attributes')

      $.get(imgURL, function (data) {
        // Get the SVG tag, ignore the rest
        let $svg = jQuery(data).find('svg')

        // Remove any invalid XML tags
        $svg = $svg.removeAttr('xmlns:a')

        // Loop through IMG attributes and apply on SVG
        $.each(attributes, function () {
          $svg.attr(this.name, this.value)
        })

        // Replace IMG with SVG
        $img.replaceWith($svg)
      }, 'xml')
    })
  }
}
